let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2pQv8")).then(() => parcelRequire('an7BE'));